export default __webpack_public_path__ + "61ce86f2bd2b3e2942858c175f0eb9a4.png";